import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WebcamModule } from 'ngx-webcam';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
// import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { SliderModule } from 'primeng/slider';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { PipeModule } from 'src/app/pipes/pipe.module';
import { GenericDesplegableModule } from '../deplegable/generic-dropdown/generic-dropdown.module';
import { SimpleTableModule } from '../table/simple-table/simple-table.modules';

import { CameraComponent } from './camera.component';

@NgModule({
    imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ToastModule,
        ButtonModule,
        TabViewModule,
        // CodeHighlighterModule,
        TableModule,
        DialogModule,
        DropdownModule,
        InputTextModule,
        MultiSelectModule,
        SliderModule,
        CalendarModule,
        RadioButtonModule,
        InputSwitchModule,
        ConfirmDialogModule,
        CheckboxModule,
        AccordionModule,
        ChipsModule,
        AutoCompleteModule,
        SimpleTableModule,
        GenericDesplegableModule,
        PipeModule,
        PanelModule,
        WebcamModule,
        CardModule],
    exports: [CameraComponent],
    declarations: [CameraComponent],
    providers: [],
})
export class CameraModule { }
